import { render } from "./LegacyAppAuthFields.vue?vue&type=template&id=096d0125"
import script from "./LegacyAppAuthFields.vue?vue&type=script&lang=js"
export * from "./LegacyAppAuthFields.vue?vue&type=script&lang=js"
script.render = render

export default script